<div class="cosmos-navbar">
  <div class="cosmos-navbar__container">
    <img
      src="assets/cosmos-logo-files/cosmos-logo.png"
      loading="lazy"
      class="cosmos-navbar__logo"
    >
  </div>
  <div class="cosmos-navbar__container-button">
    <button
      (click)="logout()"
      class="cosmos-navbar__button"
    >
      LOG OUT
    </button>
  </div>
</div>
